import { FC, TextareaHTMLAttributes } from 'react';
import { observer } from 'mobx-react-lite';
import { BaseProps, IInputSize } from '../types';
import { Message } from '../components';
import { Container } from '../common.styled';
import { Textarea } from './text-area.styled';

type TextAreaProps = Partial<BaseProps> & {
  height?: IInputSize;
} & TextareaHTMLAttributes<any>;

export const TextArea: FC<TextAreaProps> = observer(
  ({ state = 'default', width = 's', height = 's', message, ...areaProps }) => {
    return (
      <Container
        $state={state}
        $disabled={areaProps.disabled || false}
        $width={width}
      >
        <Textarea
          height={height}
          {...areaProps}
          className={`${areaProps?.className || ''}`}
        />
        {!!message?.[state] && <Message state={state} message={message} />}
      </Container>
    );
  }
);
